<template>
<el-drawer title="策划申请" :visible.sync="visible" size="100%" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div style="padding:10px 0;">
        <order-detail :orderId="order_id"></order-detail>
    </div>
    <div class="box">
        <div class="box-right">
            <!-- 执行流程 -->
            <div class="box-nav">
                <div class="box-menu">
                    <el-menu :default-active="activeIndex" mode="horizontal">
                        <el-menu-item index="purchase">采购</el-menu-item>
                    </el-menu>
                </div>
                <div class="box-nav-more">
                    <el-button type="primary" @click="closeDrawer">关闭</el-button>
                </div>
            </div>
            <!-- 四大金刚 -->
            <!-- 采购 -->
            <div class="menu-item-container" v-if="activeIndex == 'purchase'">
                <purchaset-list ref="purchase" :parent="_self"></purchaset-list>
            </div>
        </div>
    </div>
</el-drawer>
</template>

<script>
import {
    showDrawerPass
} from '@/utils/common.js';
// 订单信息
import orderDetail from '@/components/order/detail'

// 采购申请
import purchasetList from './purchase/list.vue';

const ruleForm = {
    category_id: '',
};
export default {

    components: {
        orderDetail, // 订单详情
        purchasetList, //采购

    },
    props: {
        parent: {},
    },
    data() {
        return {
            query: Object.assign({}, ruleForm),
            visible: false,
            activeIndex: 'wedding',
            order_id: 0,
            order: {},
            cameraTableData: [], // category_id = 4
            shootTableData: [], // category_id = 3
            makeupTableData: [], // category_id = 26
            compereTableData: [], // category_id=5
            rules: {},
            parents: [],
            typeId: '',
            wedding: {}, //审核标示传wedding.company_id
            route: '',
            delayList:[]
        };
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    created() {
        // let query = this.$route.query;
        this.navigationData();
    },
    methods: {
        showDialog(orderId, activeIndex, ext) {
            let _this = this;
            this.route = this.parent.router
            this.order_id = orderId;
            this.activeIndex = "purchase";
            if (ext) {
                if (ext.m == 'purchase') {
                    this.activeIndex = "purchase";
                }
            }
            //    this.$route.query 
            if (this.$refs['purchase']) {
                this.$refs['purchase'].getData(this.order_id, this.route);
            } else {
                this.$nextTick(function () {
                    this.$refs['purchase'].getData(this.order_id, this.route);
                })
            }
            // 获取订单详情
            this.getOrderDetail(this.order_id,ext);
            this.visible = true;

        },
        // 3=摄影、4=摄像、5=司仪、26=化妆
        navigationData() {
            let _this = this;
            let url = '/api/supplier.category/children';
            let query = {
                parent_id: 1
            };
            this.$post(url, query).then(res => {
                if (res.code == '200') {
                    _this.category = true;
                    _this.parents = res.data.list;

                }
            })
        },
        changeType(e) {
            let matched = this.parents.find(ele => ele.id == e);
            this.typeId = matched.id
        },
        // 获取婚庆订单详情
        getOrderDetail(orderId,ext) {
            let _this = this;
            let url = '/api/plan.order/detail';
            this.$post(url, {
                order_id: orderId
            }).then(function (res) {
                if (res.code == '200') {
                    _this.order = res.data.order;
                    _this.wedding = res.data.wedding;
                    _this.delayList = res.data.order.delayList;
                    if (ext) {
                        let typeId = ext.m;
                        let demandId = ext.demand_id;
                        let orderId = ext.order_id;
                        if (typeId == 'purchase') {
                            if (_this.$refs['purchase']) {
                                _this.$refs['purchase'].showDetail(demandId, _this.parent.route, orderId);
                            } else {
                                _this.$nextTick(function () {
                                    _this.$refs['purchase'].showDetail(demandId, _this.parent.route, orderId);
                                })
                            }
                        }

                    }
                }
            });
        },
        closeDrawer() {
            this.visible = false;
        },
    }

};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.box {
    display: flex;
    position: relative;
    height: calc(100vh - 100px);
    // height: 100vh;

    .box-left {
        flex: 0 20%;
        border-right: 1px solid #dedede;
        overflow: auto;
        padding: 12px;
    }

    .box-right {
        flex: 1;
        overflow: auto;
        display: flex;
        flex-direction: column;

        .box-nav {
            flex: 0;
            position: relative;

            .box-nav-more {
                position: absolute;
                right: 12px;
                top: 50%;
                bottom: 0;
                transform: translateY(-50%);
            }
        }

        .menu-item-container {
            flex: 1;
            overflow: auto;
        }
    }
}
</style>
